// @flow strict

import * as React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({ items }) {
  return (
    <nav className="text-sm mb-4">
      <ul className="flex gap-2 items-center">
        {items.map((item, index) => (
          <li
            key={index}
            className={`flex items-center gap-2 text-gray-500 ${index === items.length - 1 ? "" : ""
              }`}
          >
            {index === items.length - 1 ? (
              <span className="py-2 font-nunito text-[14px] text-[#333]">{item.label}</span>
            ) : (
              <Link
                to={item.link || '/'}
                className="hover:underline font-poppins font-semibold text-[18px] text-[#222] py-2"
              >
                {item.label}
              </Link>
            )}
            {index < items.length - 1 && (
              <span className="text-secondary-60 font-nunito text-[14px] text-[#333]">{">"}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Breadcrumb;